// NEW: UI_REVAMP
import { RECORD_STATUS_STYLES } from '../../styles/recordUiTokens';
import { normalizeStatusKey } from '../../utils/statusFormat';
import { getVoidActionEnabled } from './void/voidButtonUtils';

export const getRecordStatusStyle = (
	status = '',
	{ isExpire = false, variant = 'history', ticket, serverTime } = {},
) => {
	const normalizedStatus = normalizeStatusKey(status);
	const isVoidEnabled = ticket && serverTime ? getVoidActionEnabled(ticket, serverTime) : false;

	if (isVoidEnabled && normalizedStatus === 'posted') {
		return RECORD_STATUS_STYLES.voidable;
	}

	if (normalizedStatus === 'posted') {
		return RECORD_STATUS_STYLES.posted;
	}

	if (normalizedStatus === 'denied') {
		return variant === 'history'
			? RECORD_STATUS_STYLES.historyDenied
			: RECORD_STATUS_STYLES.detailDenied;
	}

	if (normalizedStatus === 'voided') {
		return variant === 'history'
			? RECORD_STATUS_STYLES.historyVoided
			: RECORD_STATUS_STYLES.detailVoided;
	}

	if (normalizedStatus === 'striked') {
		if (isExpire) {
			return {
				label: 'Posted',
				...RECORD_STATUS_STYLES.default,
			};
		}

		return RECORD_STATUS_STYLES.strike;
	}

	return {
		label: status || 'Posted',
		...RECORD_STATUS_STYLES.default,
	};
};

export const getRecordFilterChipStyle = (status = '') => {
	const normalizedStatus = normalizeStatusKey(status);

	if (normalizedStatus === 'voidable') {
		return RECORD_STATUS_STYLES.voidable;
	}

	return getRecordStatusStyle(status, { variant: 'detail' });
};
